(function () {
    'use strict';

    angular
        .module('planInitiativeModule')
        .controller('InitiativeUpdateStatusAssessByInitiativeAssessmentAssessController', Controller);

    Controller.$inject = ['$rootScope', '$scope', '$state', '$stateParams', '$mdToast', 'initiativeUpdateStatusService', 'businessPlanningService'];

    function Controller($rootScope, $scope, $state, $stateParams, $mdToast, initiativeUpdateStatusService, businessPlanningService) {
        $scope.readOnly = isReadOnly();

        $scope.completionStatuses = [];
        businessPlanningService
            .getPlanLookups()
            .then(function (containerPlanLookups) {
                $scope.completionStatuses = containerPlanLookups.CompletionStatuses;
            });

        // Show Completion Status?
        $scope.showCompletionStatus = function (completionStatus) {
            if (_.isUndefined($scope.planInitiativeAssessment.AssessmentCompletionStatusID)) return true;

            return completionStatus.LookupAttributeValueID === $scope.planInitiativeAssessment.AssessmentCompletionStatusID;
        };

        // Select Completion Status
        $scope.selectCompletionStatus = function (completionStatus) {
            if ($scope.readOnly) return;

            $scope.pageIsDirty();

            if ($scope.isCompletionStatusSelected()) {
                $scope.planInitiativeAssessment.AssessmentCompletionStatusID = undefined;
                $scope.planInitiativeAssessment.AssessmentCompletionDate = undefined;
                return;
            }

            $scope.planInitiativeAssessment.AssessmentCompletionStatusID = completionStatus.LookupAttributeValueID;

            if ($scope.isFieldRequired('AssessmentTargetDate') && _.isUndefined($scope.planInitiativeAssessment.AssessmentTargetDate)) {
                $scope.planInitiativeAssessment.AssessmentTargetDate = $scope.planInitiativeAssessment.AssessmentComputedTargetDate;
            }
        };

        $scope.isCompletionStatusSelected = function () {
            return !_.isUndefined($scope.planInitiativeAssessment.AssessmentCompletionStatusID);
        };

        // Show Reset Action?
        $scope.showResetAction = function () {
            if ($scope.readOnly) return false;

            return $scope.ctrlCtxt.needSaveChanges;
        };

        // Show Submit Action?
        $scope.showSubmitAction = function () {
            if ($scope.readOnly) return false;

            return $scope.isCompletionStatusSelected();
        };

        // Page is dirty
        $scope.ctrlCtxt.needSaveChanges = false;
        $scope.ctrlCtxt.isLoading = false;

        $scope.pageIsDirty = function () {
            $scope.ctrlCtxt.needSaveChanges = true;
            $rootScope.$broadcast('page-is-dirty');
        };

        $scope.pageIsNotDirty = function () {
            $scope.ctrlCtxt.needSaveChanges = false;
            $rootScope.$broadcast('page-is-not-dirty');
        };

        // Reset forms
        $scope.reset = function () {
            if ($scope.readOnly) return;
            $state.reload();
        };

        // Is Assess And Continue Disabled?
        $scope.isAssessAndContinueDisabled = function (form) {
            if ($scope.readOnly) return true;
            if (!$scope.isCompletionStatusSelected()) return true;

            return form.$invalid;
        };

        // Is Field Required?
        $scope.isFieldRequired = function (fieldName) {
            if (_.isUndefined(fieldName)) return false;
            if (_.isUndefined($scope.planInitiativeAssessment.AssessmentFieldConditions_ByCompletionStatusID)) return false;

            var conditionsByCompStatusID = $scope.planInitiativeAssessment.AssessmentFieldConditions_ByCompletionStatusID;

            var compStatusID = $scope.planInitiativeAssessment.AssessmentCompletionStatusID;
            if (_.isNumber(compStatusID)) compStatusID = compStatusID.toString();

            var fieldConditions = conditionsByCompStatusID[compStatusID][fieldName];

            if (_.isUndefined(fieldConditions)) return false;

            return fieldConditions['required'];
        };

        // Assess and Continue
        $scope.assessAndContinue = function (form) {
            if ($scope.readOnly) return;

            if ($scope.isAssessAndContinueDisabled(form)) {
                $scope.ctrlCtxt.showSubmitError = true;
                return;
            };
            $scope.ctrlCtxt.showSubmitError = false;

            $scope.ctrlCtxt.isLoading = true;

            initiativeUpdateStatusService
                .assessPlanInitiative($stateParams.ItemPersonID, $scope.planInitiativeAssessment)
                .then(function (updatedInitiativeAssessment) {
                    $scope.pageIsNotDirty();

                    $mdToast.show(
                        $mdToast
                            .simple()
                            .content('Initiative has been assessed')
                            .position('top right')
                            .hideDelay($scope.govNotificationDelay)
                            .action('OK')
                            .theme('primary')
                    );

                    $scope.planInitiativeAssessment = updatedInitiativeAssessment;
                    $scope.readOnly = isReadOnly();

                    var initIdx = _.findIndex($scope.initiativesList, {
                        PlanInitiative: { PlanInitiativeID: $scope.planInitiative.PlanInitiativeID }
                    });
                    $scope.initiativesList[initIdx].PlanInitiativeAssessment = updatedInitiativeAssessment;

                    var haveAllInitBeenAssessed = _.every($scope.initiativesList, {
                        PlanInitiativeAssessment: { IsLocked: true }
                    });

                    if (haveAllInitBeenAssessed) {
                        $state.go('initiativeUpdateStatusAssess.initiatives.assess.completed');
                        return;
                    }

                    initIdx += 1;
                    if (initIdx === $scope.initiativesList.length) initIdx = 0;

                    $state.go('initiativeUpdateStatusAssess.initiatives.assess.byInitiativeDeliverables', {
                        PlanInitiativeID: $scope.initiativesList[initIdx].PlanInitiative.PlanInitiativeID
                    });
                })
                .finally(function () {
                    $scope.ctrlCtxt.isLoading = false;
                });
        };

        // Go to Deliverables
        $scope.goToDeliverables = function () {
            var lastFiscalYearQuarterKey = _.last($scope.ctrlCtxt.fiscalYearQuarterKeys);

            if (!lastFiscalYearQuarterKey) {
                // Will handle no deliverables in the future
                $state.go('initiativeUpdateStatusAssess.initiatives.assess.byInitiativeDeliverables', {
                    PlanInitiativeID: $scope.planInitiativeAssessment.PlanInitiativeID,
                });

                return;
            }

            $state.go('initiativeUpdateStatusAssess.initiatives.assess.byInitiativeDeliverablesByQuarter', {
                PlanInitiativeID: $scope.planInitiativeAssessment.PlanInitiativeID,
                FiscalYearQuarterKey: lastFiscalYearQuarterKey
            });
        };

        // Helpers
        function isReadOnly() {
            if (!$scope.planInitiative) return true;
            if (!$scope.planInitiative.CanAssess) return true;

            return $scope.planInitiativeAssessment.IsLocked;
        }

    }
})();